/* Jenny Flowers: scroll reveals and smooth scrolling. Respects reduced motion; content stays visible without JS. */
(function(){
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL=['.jfi-sec .jfi-h2','.jfi-sec .jfi-sub','.jfi-sec .jfi-eyebrow','.jfi-tile','.jfi-occ a','.jfi-grid .jfi-card','.jfi-row .jfi-card','.jfi-side > div',
           '.jfi-proof-row > div','.jfi-legacy > *','.jfi-faq details','.jfi-trust li','.jfi-tabs','.jfi-more'];
  function mark(root){
    if(reduce)return;
    root.querySelectorAll(SEL.join(',')).forEach(function(el){
      if(el.hasAttribute('data-jfi-reveal'))return;
      el.setAttribute('data-jfi-reveal',el.matches('.jfi-tile,.jfi-legacy > img')?'scale':'');
      var sibs=Array.prototype.filter.call(el.parentNode.children,function(c){return c.matches&&c.matches(SEL.join(','))});
      el.style.setProperty('--jfi-i',Math.min(sibs.indexOf(el),8));
      io.observe(el);
    });
  }
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.08}):null;
  if(!io||reduce)return;
  document.documentElement.classList.add('jfi-motion');
  function start(){mark(document)}
  if(document.readyState!=='loading')start();else document.addEventListener('DOMContentLoaded',start);
  document.addEventListener('shopify:section:load',function(e){mark(e.target)});
  /* safety: never leave anything hidden */
  setTimeout(function(){document.querySelectorAll('[data-jfi-reveal]:not(.is-in)').forEach(function(el){var r=el.getBoundingClientRect();if(r.top<innerHeight)el.classList.add('is-in')})},2500);

  /* smooth wheel scrolling on desktop pointers only; pauses while Impulse drawers or modals are open */
  if(!matchMedia('(pointer: fine)').matches)return;
  var s=document.createElement('script');s.src='https://cdn.jsdelivr.net/npm/lenis@1.1.13/dist/lenis.min.js';s.defer=true;
  s.onload=function(){
    if(!window.Lenis)return;
    var lenis=new Lenis({lerp:.09,wheelMultiplier:1,smoothWheel:true});
    function raf(t){lenis.raf(t);requestAnimationFrame(raf)}requestAnimationFrame(raf);
    var lockClasses=/js-drawer-open|modal-open|overflow-hidden|lock-scroll/;
    new MutationObserver(function(){var locked=lockClasses.test(document.documentElement.className+' '+document.body.className);locked?lenis.stop():lenis.start()})
      .observe(document.body,{attributes:true,attributeFilter:['class']});
    document.querySelectorAll('a[href^="#"]').forEach(function(a){a.addEventListener('click',function(e){var id=a.getAttribute('href');if(id.length>1&&document.querySelector(id)){e.preventDefault();lenis.scrollTo(id,{offset:-90})}})});
    window.jfiLenis=lenis;
  };
  document.head.appendChild(s);
})();
